<div class="max-w-3xl mx-auto lg:p-8 md:p-4 p-2">
  <div
    class="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden mb-6"
  >
    <!-- Header con gradiente de marca -->
    <div
      class="bg-gradient-to-br from-primary to-primary-dark p-6 flex items-center gap-4 flex-wrap"
    >
      <div class="relative w-20 h-20 flex-shrink-0">
        <p-avatar
          [image]="src()"
          alt="Avatar usuario"
          shape="circle"
          [style]="{ width: '5rem', height: '5rem', 'objet-fit': 'cover' }"
          appendTo="body"
        />
        <div
          class="absolute bottom-0 right-0 w-7 h-7 flex items-center justify-center rounded-full bg-white text-primary shadow-md cursor-pointer"
          (click)="crop.open()"
          pTooltip="Cambiar imagen de perfil"
        >
          <i class="pi pi-camera text-sm leading-none" aria-hidden="true"></i>
        </div>
      </div>
      <div class="text-white">
        <h1 class="text-xl font-semibold">
          {{ usuario()?.nombre }} {{ usuario()?.apellido }}
        </h1>
        <p class="text-sm opacity-90">{{ usuario()?.correo }}</p>
      </div>
      @if (!editMode) {
        <petrol-button
          variant="tertiary"
          class="ml-auto"
          (click)="enableEditMode()"
        >
          Editar perfil
        </petrol-button>
      }
    </div>

    <div class="p-6">
      @if (!editMode) {
        <!-- Vista de solo lectura -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <span
              class="block text-xs font-bold uppercase tracking-wide text-slate-400"
            >
              Nombre
            </span>
            <p class="text-slate-800">{{ usuario()?.nombre }}</p>
          </div>
          <div>
            <span
              class="block text-xs font-bold uppercase tracking-wide text-slate-400"
            >
              Apellido
            </span>
            <p class="text-slate-800">{{ usuario()?.apellido }}</p>
          </div>
          <div>
            <span
              class="block text-xs font-bold uppercase tracking-wide text-slate-400"
            >
              Correo
            </span>
            <p class="text-slate-800">{{ usuario()?.correo }}</p>
          </div>
          <div>
            <span
              class="block text-xs font-bold uppercase tracking-wide text-slate-400"
            >
              CUIL
            </span>
            <p class="text-slate-800">{{ usuario()?.cuil }}</p>
          </div>
          <div>
            <span
              class="block text-xs font-bold uppercase tracking-wide text-slate-400"
            >
              Usuario de acceso
            </span>
            <p class="text-slate-800">{{ usuario()?.email }}</p>
          </div>
        </div>
      } @else {
        <!-- Modo edición -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <c-input
            etiqueta="Nombre"
            placeholder="Ingrese el nombre"
            [valor]="usuario()?.nombre"
            (valorChange)="updateUsuarioValue($event, 'nombre')"
          />
          <c-input
            etiqueta="Apellido"
            placeholder="Ingrese apellido"
            [valor]="usuario()?.apellido"
            (valorChange)="updateUsuarioValue($event, 'apellido')"
          />
        </div>
        <c-input
          etiqueta="Correo"
          placeholder="Ingrese correo"
          [readonly]="true"
          [valor]="usuario()?.correo"
          (valorChange)="updateUsuarioValue($event, 'correo')"
        />
        <c-input
          etiqueta="CUIL"
          placeholder="Ingrese el CUIL"
          [readonly]="true"
          [valor]="usuario()?.cuil"
          (valorChange)="updateUsuarioValue($event, 'cuil')"
        />
        <c-input
          etiqueta="Usuario de acceso"
          placeholder="Ingrese el usuario de acceso"
          [readonly]="true"
          [valor]="usuario()?.email"
          (valorChange)="updateUsuarioValue($event, 'email')"
        />

        <div class="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
          <petrol-button variant="tertiary" (click)="cancelEdit()">
            Cancelar
          </petrol-button>
          <petrol-button variant="primary" (click)="saveEdit()">
            Guardar cambios
          </petrol-button>
        </div>
      }
    </div>
  </div>

  <!-- Información adicional (solo lectura, datos ya cargados en usuario) -->
  <div
    class="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden mb-6"
  >
    <div class="px-6 py-3 border-b border-slate-100 bg-slate-50">
      <h3 class="text-sm font-bold uppercase tracking-wide text-slate-700">
        Información adicional
      </h3>
    </div>
    <div class="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <span
          class="block text-xs font-bold uppercase tracking-wide text-slate-400"
        >
          Legajo
        </span>
        <p class="text-slate-800">
          {{ usuario()?.legajo || 'No especificado' }}
        </p>
      </div>
      <div>
        <span
          class="block text-xs font-bold uppercase tracking-wide text-slate-400"
        >
          Empresa
        </span>
        <p class="text-slate-800">
          {{ usuario()?.empresa?.nombre || 'No especificado' }}
        </p>
      </div>
      <div>
        <span
          class="block text-xs font-bold uppercase tracking-wide text-slate-400"
        >
          Fecha de alta
        </span>
        <p class="text-slate-800">
          {{
            (usuario()?.fecha_alta | date: 'dd/MM/yyyy') || 'No especificado'
          }}
        </p>
      </div>
      <div class="sm:col-span-2">
        <span
          class="block text-xs font-bold uppercase tracking-wide text-slate-400 mb-1"
        >
          Roles asignados
        </span>
        <div class="flex flex-wrap gap-2">
          @for (rol of usuario()?.roles; track rol.id) {
            <petrol-badge status="info">{{ rol.nombre }}</petrol-badge>
          } @empty {
            <p class="text-slate-500 italic text-sm">No especificado</p>
          }
        </div>
      </div>

      <div class="sm:col-span-2">
        <span
          class="block text-xs font-bold uppercase tracking-wide text-slate-400 mb-1"
        >
          Factor de doble autenticación
        </span>
        <div class="flex flex-wrap gap-2">
          <bt-toggle
            description="¿Desea activar la autenticación por doble factor? Le llegarán a su correo los códigos de acceso"
            activeText="Si"
            nonActiveText="no"
            [toggleOnly]="false"
            [active]="usuario()?.twoFactorAuth ?? false"
            (activeChange)="changeTwoFactorAuth($event)"
          />
        </div>
      </div>
    </div>
  </div>

  <div
    class="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden mb-6"
  >
    <c-user-session [dobleFactorActivado]="usuario()?.twoFactorAuth ?? false" />
  </div>

  <!-- Cambiar contraseña (misma lógica de siempre) -->
  <div
    class="bg-white rounded-lg shadow-md border border-slate-200 overflow-hidden"
  >
    <div class="px-6 py-3 border-b border-slate-100 bg-slate-50">
      <h3 class="text-sm font-bold uppercase tracking-wide text-slate-700">
        Contraseña
      </h3>
    </div>
    <div class="p-6">
      <div class="hide" [ngClass]="{ show: correctAuthentication }">
        <div>
          <c-input
            tipo="password"
            etiqueta="Contraseña"
            placeholder="Ingrese su nueva contraseña"
            [(valor)]="newPassword"
            [estricto]="true"
            [hardError]="passwordError()"
            (valido)="claveValid = $event"
          />
          <c-input
            tipo="password"
            etiqueta="Repita contraseña"
            placeholder="Repita su nueva contraseña"
            [(valor)]="repeatPassword"
          />
          <br />
          <div class="flex justify-end">
            <petrol-button variant="tertiary" (click)="changePassword()">
              Confirmar
            </petrol-button>
          </div>
        </div>
      </div>

      <div
        class="flex justify-start"
        [ngClass]="{ 'mt-4': correctAuthentication }"
      >
        <petrol-button
          variant="primary"
          (click)="
            correctAuthentication()
              ? correctAuthentication.set(false)
              : visible.set(true)
          "
        >
          {{ correctAuthentication() ? 'Cancelar' : 'Cambiar contraseña' }}
        </petrol-button>
      </div>
    </div>
  </div>

  <div class="flex justify-start mt-6">
    <petrol-button variant="tertiary" (click)="goBack()">Volver</petrol-button>
  </div>
</div>

<c-crop-image (btnClick)="cargarImagen($event, crop)" #crop />

<c-dialog #dialog />

<p-dialog
  [visible]="visible()"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [closable]="true"
  [style]="{ width: '90vw' }"
  [closeOnEscape]="false"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="flex justify-start items-start flex-col">
      <h1 class="text-xl"><b>Cambio contraseña</b></h1>
      <small class="mb-4 italic opacity-80">
        <b>
          Ingrese su contraseña para autenticar su usuario y continuar con el
          cambio de contraseña.
        </b>
      </small>
    </div>
  </ng-template>
  <c-input
    tipo="password"
    etiqueta="Contraseña"
    placeholder="Ingrese su nueva contraseña"
    [(valor)]="password"
    [showError]="error()"
    mensajeError="Debe completar este campo"
  />
  <br />
  <div class="flex justify-end">
    <petrol-button variant="primary" (click)="checkPass(password)">
      Confirmar
    </petrol-button>
  </div>
</p-dialog>
